<template>
  <b-nav-item-dropdown
      class="dropdown-notification"
      menu-class="dropdown-menu-media"
      toggle-class="p-0 d-flex align-items-center"
      right
  >
    <template #button-content>
      <div class="nav-circle-btn" :title="$t('Notifications') || 'Bildirimler'">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        <span v-if="unReadCount > 0" class="nav-notification-dot"></span>
      </div>
    </template>

    <b-overlay :show="loading" no-center variant="transparent" rounded="sm">
      <template #overlay>
        <loading-spinner/>
      </template>

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex">
          <h4 class="notification-title mb-0 mr-auto">
            {{ $t('Notifications') }}
          </h4>
        </div>
      </li>

      <!-- Notifications -->
      <vue-perfect-scrollbar
          class="scrollable-container media-list scroll-area"
          tagname="li"
      >
        <!-- Account Notification -->
        <b-link
            v-for="notification in notifications"
            :key="notification.uuid"
            class="notification-item"
            :href="convertUrl(notification.redirectUrl)"
        >
          <b-media :class="{unread: !notification.seen}">
            <template #aside>
              <b-img :src="notification.image" height="32" width="32"/>
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ notification.messageText }}
              </span>
            </p>
            <small class="notification-text">
              {{ fromNow(notification.createdAt) }}
            </small>
          </b-media>
        </b-link>
        <div
          v-if="!loading && notifications.length === 0"
          class="notification-empty"
        >
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <span>{{ $t('No notifications yet') }}</span>
        </div>
      </vue-perfect-scrollbar>

      <!-- Cart Footer -->
      <li class="dropdown-menu-footer">
        <span class="mark-read-all" :style="!unReadCount ? 'opacity: 0.7;' : ''"
              @click="unReadCount ? markReadAll() : null" >

        </span>
      </li>
    </b-overlay>

  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox, BOverlay, BImg,
} from 'bootstrap-vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import useJwt from '@/auth/jwt/useJwt'
import {showNotify, throwDefaultError} from '@/helpers/helpers'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BImg,
    BLink,
    BAvatar,
    BButton,
    BFormCheckbox,
    BOverlay,

    LoadingSpinner,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      iconHeart: require('@/assets/images/icons/heart-2.svg'),
      iconChat: require('@/assets/images/icons/chat-2.svg'),
      loading: false,
      notifications: []
    }
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.type === 'show' && this.unReadCount > 0) {
        this.markReadAll()
      }
    })
  },
  created() {
    this.getNotifications()
  },
  computed: {
    unReadCount() {
      return this.notifications.filter(n => !n.seen).length
    }
  },
  methods: {
    convertUrl(url){
      const _url = new URL(url);
      return _url.pathname
    },
    fromNow(date) {
      return moment(date).locale(this.$i18n.locale).fromNow()
    },
    getNotifications() {
      this.loading = true
      useJwt.getNotifications()
          .then(response => {
            this.notifications = response.data.body.onSiteNotifications
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
          })
    },
    markReadAll() {
      this.loading = true
      useJwt.markAllNotificationsAsRead()
          .then(response => {
            // showNotify(this.$toast, 'Bildirimler okundu olarak işaretlendi', 'success')
            this.getNotifications()
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.mark-read-all {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #F25674;
  cursor: pointer;
}
body:not(.dark-layout) {
  .dropdown-notification {
    .notification-item {
      .media.unread {
        background-color: #efefef;
      }
      .media:hover {
        background-color: #efefef;
      }
    }
  }
}
body.dark-layout {
  .dropdown-notification {
    .notification-item {
      .media.unread {
        background-color: #161d31;
      }
    }
  }
}

.dropdown-notification {
  ::v-deep .dropdown-toggle {
    padding: 0 !important;
    &::after {
      display: none !important;
    }
  }

  .nav-circle-btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #ffffff;
    transition: all 0.2s ease;
    cursor: pointer;

    @media (max-width: 576px) {
      width: 34px;
      height: 34px;

      svg {
        width: 16px;
        height: 16px;
      }

      .nav-notification-dot {
        top: 6px;
        right: 7px;
        width: 6px;
        height: 6px;
      }
    }

    &:hover {
      background: rgba(255, 255, 255, 0.16);
      color: #ffffff;
    }

    .nav-notification-dot {
      position: absolute;
      top: 7px;
      right: 8px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #ea03b2;
      border: 1.5px solid #11172b;
    }
  }
}

/* ---------- Koyu tema + mobil uyum ---------- */
.dropdown-notification {
  ::v-deep .dropdown-menu-media {
    width: 360px !important;
    padding: 0 !important;
    overflow: hidden;
    background: #18132b !important;
    border: 1px solid rgba(150, 110, 255, 0.28) !important;
    border-radius: 16px !important;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.65) !important;
    margin-top: 10px !important;

    @media (max-width: 767px) {
      position: fixed !important;
      top: 68px !important;
      right: 8px !important;
      left: 8px !important;
      transform: none !important;
      width: auto !important;
      max-width: none !important;
      min-width: 0 !important;
    }

    .dropdown-menu-header {
      border-bottom: 1px solid rgba(150, 110, 255, 0.2);

      .dropdown-header {
        padding: 14px 18px !important;
        background: linear-gradient(135deg, rgba(234, 3, 178, 0.18) 0%, rgba(168, 85, 247, 0.14) 50%, rgba(99, 102, 241, 0.08) 100%);
      }

      .notification-title {
        color: #fff !important;
        font-size: 16px;
        font-weight: 700;
      }
    }

    .scrollable-container {
      max-height: min(420px, calc(100vh - 160px));
    }

    .notification-item {
      display: block;
      text-decoration: none;

      .media {
        padding: 12px 18px;
        border-bottom: 1px solid rgba(150, 110, 255, 0.12) !important;
        background: transparent !important;
        transition: background .15s ease;

        &:hover { background: rgba(139, 92, 246, 0.14) !important; }

        &.unread {
          background: rgba(234, 3, 178, 0.1) !important;
          box-shadow: inset 3px 0 0 #ea03b2;
        }

        img {
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid rgba(234, 3, 178, 0.45);
        }
      }

      .media-heading {
        color: #fff !important;
        font-size: 13.5px;
        line-height: 18px;
        margin-bottom: 4px;
        white-space: normal;
        word-break: break-word;

        span { color: #fff !important; }
      }

      .notification-text {
        color: rgba(226, 220, 255, 0.6) !important;
        font-size: 12px;
      }
    }

    .notification-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      padding: 30px 18px;
      color: rgba(226, 220, 255, 0.7);
      font-size: 14px;

      svg { color: #f472b6; }
    }

    .dropdown-menu-footer {
      display: none;
    }
  }
}
</style>
